module.exports = __webpack_public_path__ + "img/empty-media-library.4e24f9a4.svg";